import { esri } from './esri.config';
import { layers } from './layers.config';
import { timeline } from './timeline.config';
import { leftpanel } from './leftpanel.config';
import { audit } from './audit.config';
import { helpertext } from './helperText.config';

const config = {
  esri,
  layers,
  timeline,
  leftpanel,
  audit,
  helpertext,
};

export default config;
